import { createAction, props } from '@ngrx/store'
import { Billing } from './billing.model'

export const LoadCharges = createAction('[Billing] Load Charges')
export const LoadChargesComplete = createAction('[Billing] Load Charges Complete', props<{ billings: Billing[] }>())
